module.exports = "<canvas class=particles (window:resize)=\"setCanvasSize()\" #particles></canvas>"